// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RzO8V","buttons":"styles_buttons__pfkr6"};